import { IsEmail, IsEnum, IsNotEmpty, IsString } from '@pristine-ts/class-validator';
import { translationBaseKey } from '../../decorators/translation-base-key.decorator';

import { ClientQuestionnaireKeynameEnum } from '../../enums/client-questionnaire/client-questionnaire-keyname.enum';
import { ErrorMessageBuilder } from '../../builders/error-message.builder';
import {advancedFormControl, FormControlTypeEnum} from '@magieno/common';

@translationBaseKey('client-questionnaire-creation-options')
export class ClientQuestionnaireCreationOptions {
  //todo maybe we want a select here ?
  @advancedFormControl({
    type: FormControlTypeEnum.Input,
  })
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsEnum(ClientQuestionnaireKeynameEnum, { buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  keyname: ClientQuestionnaireKeynameEnum;

  @advancedFormControl({
    type: FormControlTypeEnum.Input,
  })
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  clientName: string;

  @advancedFormControl({
    type: FormControlTypeEnum.Input,
  })
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsEmail({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  clientEmail: string;
}
